import { render, staticRenderFns } from "./Label.vue?vue&type=template&id=4e231ade&scoped=true&"
import script from "./Label.vue?vue&type=script&lang=js&"
export * from "./Label.vue?vue&type=script&lang=js&"
import style0 from "./Label.vue?vue&type=style&index=0&id=4e231ade&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e231ade",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/danford/drochat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e231ade')) {
      api.createRecord('4e231ade', component.options)
    } else {
      api.reload('4e231ade', component.options)
    }
    module.hot.accept("./Label.vue?vue&type=template&id=4e231ade&scoped=true&", function () {
      api.rerender('4e231ade', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/ui/Label.vue"
export default component.exports